export const inmagine_login = () => {
    window.localStorage.setItem('last_url', window.location.href);
    window.location.href = global.config.designs_ai_server_path + "user/sign-in?c=" + global.config.dm_client_id + "&r=" + global.config.auth_redirect_path_dm;
};

export const inmagine_logout = () => {
    window.localStorage.setItem('last_url', window.location.href);
    fetch(global.config.server_path + 'user/logout', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        'credentials': 'include'
    })
        .then(res => {
            window.location.href = global.config.designs_ai_server_path + "user/sign-out?c=" + global.config.dm_client_id + "&r=" + global.config.auth_redirect_path_dm;
        })
        .catch(err => {
            console.error(err);
            window.location.href = global.config.designs_ai_server_path + "user/sign-out?c=" + global.config.dm_client_id + "&r=" + global.config.auth_redirect_path_dm;
        })
};

export const inmagine_signup = () => {
    window.localStorage.setItem('last_url', window.location.href);
    window.location.href = global.config.designs_ai_server_path + "user/sign-up?c=" + global.config.dm_client_id + "&r=" + global.config.auth_redirect_path_dm;
};

export const loginHandler = (action) => {
    if (action === 'login') {
        inmagine_login();
    } else if (action === 'logout') {
        inmagine_logout();
    } else if (action === 'signup') {
        inmagine_signup();
    }
}
